import {
  useFormContext,
  type FieldPath,
  type FieldValues,
} from "react-hook-form"

import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form"
import MultiSelect, { type Option } from "@/components/ui/multiselect"

interface FormMultiselectProps<T extends FieldValues> {
  name: FieldPath<T>
  label?: string
  options: Option[]
  placeholder?: string
  className?: string
  badgeClassName?: string
  disabled?: boolean
  maxSelected?: number
  groupBy?: string
  hideClearAllButton?: boolean
  onChange?: (value: Option[]) => void
}

export function FormMultiselect<T extends FieldValues>({
  name,
  label,
  options,
  placeholder = "Select options",
  className,
  badgeClassName,
  disabled = false,
  maxSelected,
  groupBy,
  onChange,
}: FormMultiselectProps<T>) {
  const form = useFormContext<T>()

  return (
    <FormField
      control={form.control}
      name={name}
      render={({ field }) => (
        <FormItem className={className}>
          {label && <FormLabel>{label}</FormLabel>}
          <FormControl>
            <MultiSelect
              value={field.value || []}
              onChange={(selected: Option[]) => {
                field.onChange(selected)
                onChange?.(selected)
              }}
              options={options}
              placeholder={placeholder}
              badgeClassName={badgeClassName}
              disabled={disabled}
              maxSelected={maxSelected}
              groupBy={groupBy}
              hideClearAllButton={true}
              hidePlaceholderWhenSelected={true}
            />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  )
}

export default FormMultiselect
